import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

/** Tipos de tecnología RFID (la clave es la que guarda el API). */
export const RFID_DEVICE_TYPES: ReadonlyArray<{ id: string; name: string }> = [
  { id: 'WIDGET_PC',           name: 'Widget computadora' },
  { id: 'WIDGET_CELULAR',      name: 'Widget celular' },
  { id: 'BANDEJA_LECTORA',     name: 'Bandeja lectora' },
  { id: 'ANTENA_LECTORA',      name: 'Antenas lectoras' },
  { id: 'ANAQUEL_INTELIGENTE', name: 'Anaquel inteligente' },
];
/** Proveedores de la tecnología RFID (se guarda en mayúsculas). */
export const RFID_PROVIDERS: ReadonlyArray<{ id: string; name: string }> = [
  { id: 'TERSO',  name: 'Terso' },
  { id: 'CHAFON', name: 'Chafon' },
  { id: 'IMPINJ', name: 'Impinj' },
];
/** Texto del Excel → proveedor válido (o null). */
export function rfidProviderFromText(v: any): string | null {
  const t = String(v ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toUpperCase();
  return RFID_PROVIDERS.some(p => p.id === t) ? t : null;
}

/** Los widgets se mueven entre lockers: para ellos el locker es opcional. */
export const RFID_WAREHOUSE_OPTIONAL = ['WIDGET_PC', 'WIDGET_CELULAR'];

/** Texto del Excel ("Bandeja lectora" o BANDEJA_LECTORA) → clave, o null. */
export function rfidTypeFromText(v: any): string | null {
  const norm = (x: any) => String(x ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toUpperCase().replace(/[\s-]+/g, '_');
  const t = norm(v);
  if (!t) return null;
  return RFID_DEVICE_TYPES.find(o => o.id === t || norm(o.name) === t)?.id ?? null;
}

/** Catálogo de Tecnología RFID: recurso REST /rfidDevices. */
@Injectable({ providedIn: 'root' })
export class RfidDevicesService extends ApiBaseService<any> {
  constructor() {
    super('rfidDevices');
  }
}
